// Banks Getters

export const getBanksList = state => {
  return state.banksList
}

export const getFullBanksList = state => {
  return state.fullBanksList
}

export const getBankInfo = state => {
  return state.bankInfo
}
